import { useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';
import { BFFClient } from '~settings/api/lib/BFFClient';

import { LabelGroupQueryKeys } from '../config/queryKeys';
import { getRequestHeaders } from '../lib/headers';
import type { LabelGroupDetail } from '../lib/schemas';
import { LabelGroupDetailSchema } from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

export interface LabelGroupDetailQueryVariables {
  labelGroupId: string;
}

export function useLabelGroupDetails<TData = LabelGroupDetail>(
  variables: LabelGroupDetailQueryVariables,
  options?: PresetUseQueryOptions<LabelGroupDetail, TData>,
) {
  const { token } = useWmgSession();

  const { labelGroupId } = variables;

  const { data, ...query } = useQuery({
    queryKey: LabelGroupQueryKeys.detail(variables),
    queryFn: async () => {
      const responseData = await BFFClient.get(`label-groups/${labelGroupId}`, {
        headers: getRequestHeaders(token),
      }).json();

      return LabelGroupDetailSchema.parse(responseData);
    },
    enabled: Boolean(labelGroupId),
    ...options,
  });

  return { labelGroup: data, ...query };
}
